import React from "react";
import { LandingPage } from "../LandingPage/LandingPage";

export const Home = () => {
  return <LandingPage />;
};
